import axios from '@axios'

export default {
  getConta: () => axios.get(`${process.env.VUE_APP_NOVITATUS_API}/minhaconta`),
  listInteresse: () => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/minhaconta/interesses`,
    {
      params: { size: 200 },
    },
  ),
  listAnexo: () => axios.get(`${process.env.VUE_APP_NOVITATUS_API}/minhaconta/anexos`, {
    params: { size: 200 },
  }),
  createAnexo: anexo => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/minhaconta/anexos`,
    anexo,
  ),
  deleteAnexo: anexoId => axios.delete(
    `${process.env.VUE_APP_NOVITATUS_API}/minhaconta/anexos/${anexoId}`,
  ),
  listEmpresa: () => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/minhaconta/empresas`,
    {
      params: { size: 200 },
    },
  ),
}
